import axios from 'axios';

let axiosSource = axios.CancelToken.source();

export function cancelAllAxiosRequests() {
  axiosSource.cancel('All Axios requests cancelled');
  axiosSource = axios.CancelToken.source();
}

axios.interceptors.request.use(config => {
  config.cancelToken = axiosSource.token;
  return config;
});

  